import { HashRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SkillsPage from "./pages/SkillsPage";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import ExperiencePage from "./pages/ExperiencePage";
import CertificationsPage from "./pages/CertificationsPage";
import NotFound from "./pages/NotFound";
import ProjectDetails from "./pages/ProjectDetails";
import MoreCertificates from "./pages/MoreCertificates";
import ProjectGallery from "./pages/ProjectGallery";



function App() {
  return (
    <HashRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/skills" element={<SkillsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/experience" element={<ExperiencePage />} />
        <Route path="/certifications" element={<CertificationsPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetails />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/certifications/more" element={<MoreCertificates />} />
        <Route path="/project-gallery" element={<ProjectGallery />} />
      </Routes>

      <Footer />
    </HashRouter>
  );
}

export default App;


